import { render, staticRenderFns } from "./ab-cust-dialog-list.vue?vue&type=template&id=48145158&"
import script from "./ab-cust-dialog-list.vue?vue&type=script&lang=js&"
export * from "./ab-cust-dialog-list.vue?vue&type=script&lang=js&"
import style0 from "./ab-cust-dialog-list.vue?vue&type=style&index=0&id=48145158&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports